import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../pages/css/EmailFinderVerifier.css";
import banner from '../images/Hrias-b2b-banner.png';
import verifiedemail from '../images/Hrias-email-verified.png';
import verifiedemail90 from '../images/Hrias-email-verification.png'
import emailSources from '../images/Hrias-email-sources.png';
import outreach from '../images/Hrias-b2b-outreach.png'
import b2bcrm from '../images/Hrias-b2b-CRM.png';
import customDev from '../images/Hrias-Custom_Development.png';
import cTOne from '../images/kpmg.png';
import cTTwo from '../images/deloite.png';
import cTThree from '../images/berkshire.png';
import cTFive from '../images/pwc.jpg';
import cTSix from '../images/microsoft.png';
import cTFour from '../images/Google.png';
import dashImg from '../images/Hrias-email-dash.jpg';

function EmailFinderVerifier() {
  return (
    <div className="email-finder-page">

      <section
        className="hero-section text-center text-white d-flex align-items-center justify-content-center"
        style={{
          backgroundImage:
            `url(${banner})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          width: "100%",
          height: "40vh",
        }}
      >
        <div className="container" style={{ color: "#ffffff" }}>
          <h1 className="fw-bold" style={{ color: "#275a8eff" }}>
            AI-Powered <span className="highlight" style={{ color: "#7102c1ff" }}>Email Finder & Verifier</span> with HRIAS
          </h1>
          <p className="lead mt-3" style={{ color: "#890059ff" }}>
            Instantly find and verify professional emails from millions of business contacts.
            Save hours, boost conversions, and grow your outreach effortlessly.
          </p>
          <button
            className="btn btn-primary mt-4"
            style={{
              backgroundColor: "#134373ff",
              border: "none",
              color: "#ffffffff",
              fontWeight: "600",
              borderRadius: "30px",
              padding: "12px 30px",
              transition: "all 0.3s ease",
            }}
            onMouseOver={(e) => (e.target.style.backgroundColor = "#5197dcff")}
            onMouseOut={(e) => (e.target.style.backgroundColor = "#134373ff")}
          >
            Contact Sales
          </button>
        </div>

      </section>

      <section>
        <div className="container py-5">
          <img
            src={dashImg}
            alt="Padded Container"
            className="img-fluid rounded shadow-lg"
          />
        </div>
      </section>

      <section className="container my-5 partner-section">
        {/* Heading */}
        <h5 className="text-center partner-heading">
          Trusted by <span style={{ color: '#fd7e14' }}>6000+</span> Industry Leaders
        </h5>

        {/* Logo Row */}
        <div className="d-flex justify-content-center align-items-center flex-wrap gap-4 mt-4">
          <img src={cTOne} alt="KPMG" className="partner-logo" style={{ width: '120px', height: 'auto' }} />
          <img src={cTTwo} alt="Deloitte" className="partner-logo" style={{ width: '130px', height: 'auto' }} />
          <img src={cTThree} alt="Berkshire" className="partner-logo" />
          <img src={cTFour} alt="Google" className="partner-logo" />
          <img src={cTFive} alt="PwC" className="partner-logo" />
          <img src={cTSix} alt="Microsoft" className="partner-logo" />
        </div>
      </section>


      {/* Hero Section */}
      {/* <section className="hero-section text-center py-5">
        <div className="container">
          <h1 className="fw-bold hero-title">
            AI-Powered <span className="highlight">Email Finder & Verifier</span>
          </h1>
          <p className="lead text-muted mt-3">
            Instantly find and verify professional emails from millions of business contacts.
            Save hours, boost conversions, and grow your outreach effortlessly.
          </p>
          <button className="btn btn-primary contact-btn mt-4">Contact Sales</button>
        </div>
      </section> */}

      {/* Section 2: How It Works */}
      <section className="how-it-works py-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 text-section">
              <h2 className="section-heading">Find and Verify Emails in Seconds</h2>
              <p className="text-muted">
                Use HRIAS’s smart AI engine to discover verified B2B emails by name,
                company, or domain. Every email is validated in real-time, ensuring
                your campaigns never bounce again.
              </p>
            </div>
            <div className="col-md-6 text-center">
              <img
                src={verifiedemail}
                alt="Email Finder"
                className="img-fluid rounded shadow"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Section 3: Verification Accuracy */}
      <section className="accuracy-section py-5 bg-light">
        <div className="container text-center">
          <h2 className="section-heading">90% Verification Accuracy</h2>
          <p className="text-muted mb-4">
            With real-time SMTP validation, AI spam detection, and domain checks, you can trust
            every verified contact you export from HRIAS.
          </p>
          <img
            src={verifiedemail90}
            alt="Verification Process"
            className="img-fluid rounded shadow"
          />
        </div>
      </section>

      {/* Section 4: Multi-Source Data Collection */}
      <section className="multi-source py-5">
        <div className="container">
          <div className="row align-items-center flex-md-row-reverse">
            <div className="col-md-6 text-section">
              <h2 className="section-heading">Smart Multi-Source Data Collection</h2>
              <p className="text-muted">
                HRIAS scans multiple business databases, company websites, and LinkedIn profiles
                to ensure you get the most updated and accurate contact information available.
              </p>
            </div>
            <div className="col-md-6 text-center">
              <img
                src={emailSources}
                alt="Data Sources"
                className="img-fluid rounded shadow"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Section 5: CRM Integration */}
      <section className="crm-section py-5 bg-light">
        <div className="container text-center">
          <h2 className="section-heading">Instant CRM Integration</h2>
          <p className="text-muted mb-4">
            Export your verified leads directly to HubSpot, Salesforce, or any CRM of your choice
            with a single click. No manual uploads, no wasted time.
          </p>
          <img
            src={b2bcrm}
            alt="CRM Integration"
            className="img-fluid rounded shadow"
          />
        </div>
      </section>

      <section className="container my-5 client-review-section">
        <div className="row align-items-center">
          {/* Left side - client image */}
          <div className="col-12 col-md-3 text-center">
            <img
              src="https://img.freepik.com/free-photo/portrait-white-man-isolated_53876-40306.jpg?semt=ais_hybrid&w=740&q=80" // replace with your client's photo
              alt="Client"
              className="client-img"
            />
          </div>

          {/* Right side - review text */}
          <div className="col-12 col-md-9">
            <p className="client-review">
              “HRIAS Verified Email Database helped our team connect with genuine business professionals and decision-makers effortlessly.
              The deliverability rate is exceptional — no more bounces or invalid addresses.
              It has streamlined our campaigns and dramatically improved our email outreach performance!”
            </p>
            <h3 className="client-name">Flunto Johansen</h3>
            <p className="client-position">Tech Head, US Tech.</p>

          </div>
        </div>
      </section>


      {/* Section 6: Call to Action */}
      <section className="cta-section py-5 text-center">
        <div className="container">
          <h2 className="fw-bold fw-bold mb-3 text-white">Start Finding Verified Leads Today</h2>
          <p className="cta-subtitle mt-3 mb-4">
            Stop guessing. Start connecting with decision-makers who matter.
          </p>
          <button className="btn btn-primary px-4 py-2" >Contact Sales</button>
        </div>
      </section>
    </div>
  );
}

export default EmailFinderVerifier;
